// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDs2xxtzjyO1MWnqpJvbvkpAUYJxqm5YSE",
    authDomain: "nottsify.com",
    projectId: "nottsify-4381b",
    storageBucket: "nottsify-4381b.firebasestorage.app",
    messagingSenderId: "805783012984",
    appId: "1:805783012984:web:99c98580e71fbc460f4f8d"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app); // Initialize Firestore
const googleProvider = new GoogleAuthProvider();

export default app;
export { auth, db, googleProvider }; // Export db
